module.exports = __webpack_public_path__ + "img/step3-c.37686728.png";